import React, { useState } from "react";
import styles from "./ContactPromptSection.module.css";
import myImage from "../img/myImage.png";
import { submitContactForm } from "../utils/contactApi";

function ContactPromptSection() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    setIsSubmitting(true);
    setStatusMessage("");

    try {
      const result = await submitContactForm(formData);
      setStatusMessage(result.message || "Nachricht erfolgreich gesendet.");
      form.reset();
    } catch (error) {
      setStatusMessage(
        `Fehler beim Senden der Nachricht: ${error.message}`
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className={styles.section}>
      <div className={styles.layout}>
        <div className={styles.copy}>
          <p className={styles.label}>
            <span className="accent-underline">Kontakt</span> aufnehmen
          </p>
          <h2 className={styles.title}>Du hast Fragen?</h2>
          <p className={styles.text}>
            Zögere nicht, uns zu kontaktieren, um direkt und unverbindlich mit
            einem unserer Experten verbunden zu werden.
          </p>
          <form className={styles.form} onSubmit={handleSubmit} autoComplete="on">
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label htmlFor="inline-firstName">Vorname*</label>
                <input
                  id="inline-firstName"
                  name="firstName"
                  type="text"
                  autoComplete="given-name"
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="inline-lastName">Nachname*</label>
                <input
                  id="inline-lastName"
                  name="lastName"
                  type="text"
                  autoComplete="family-name"
                  required
                />
              </div>
            </div>
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label htmlFor="inline-companyName">Unternehmensname</label>
                <input
                  id="inline-companyName"
                  name="companyName"
                  type="text"
                  autoComplete="organization"
                />
              </div>
            </div>
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label htmlFor="inline-position">Position</label>
                <input
                  id="inline-position"
                  name="position"
                  type="text"
                  autoComplete="organization-title"
                />
              </div>
            </div>
            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label htmlFor="inline-email">E-Mail*</label>
                <input
                  id="inline-email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="inline-phoneNumber">Telefonnummer</label>
                <input
                  id="inline-phoneNumber"
                  name="phoneNumber"
                  type="tel"
                  autoComplete="tel"
                />
              </div>
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="inline-topic">
                Bei welchem Thema können wir Sie unterstützen?*
              </label>
              <input
                id="inline-topic"
                name="topic"
                type="text"
                autoComplete="off"
                required
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="inline-message">Nachricht</label>
              <textarea
                id="inline-message"
                name="message"
                autoComplete="off"
                rows="5"
              />
            </div>
            <label className={styles.checkboxRow}>
              <input type="checkbox" name="agbAccepted" required />
              <span>Ich habe die AGB gelesen und akzeptiere sie.</span>
            </label>
            <button className={styles.button} type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Wird gesendet..." : "Nachricht senden"}
            </button>
            {statusMessage ? (
              <p className={styles.statusMessage}>{statusMessage}</p>
            ) : null}
          </form>
        </div>
        <div className={styles.profile}>
          <img
            src={myImage}
            alt="Charles David Mupende"
            className={styles.image}
          />
          <div className={styles.signature}>
            <h3 className={styles.name}>Charles David Mupende</h3>
            <p className={styles.role}>Gründer</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactPromptSection;
